import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { useLocation } from "../lib/location";
import CityPicker from "./CityPicker";

const PLACEHOLDERS = [
  "Buscar parafusadeira...",
  "Buscar lavadora de alta pressão...",
  "Buscar martelete...",
  "Buscar betoneira...",
  "Buscar furadeira...",
  "Buscar gerador...",
];

function useRotatingPlaceholder() {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % PLACEHOLDERS.length), 2500);
    return () => clearInterval(t);
  }, []);
  return PLACEHOLDERS[idx];
}

export default function Header() {
  const { location, setLocation } = useLocation();
  const [q, setQ] = useState("");
  const placeholder = useRotatingPlaceholder();
  const nav = useNavigate();

  const onSearch = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (location?.city) params.set("city", location.city);
    nav(`/buscar?${params.toString()}`);
  };

  return (
    <header
      className="sticky top-0 z-30 bg-[#004E98] text-white shadow-md"
      style={{ paddingTop: "var(--safe-area-inset-top, env(safe-area-inset-top, 0px))" }}
      data-testid="app-header"
    >
      <div className="max-w-7xl mx-auto px-4 py-3 space-y-3">
        <div className="flex items-center justify-between gap-3">
          <CityPicker
            value={location}
            onChange={(v) => setLocation({ ...v, radius_km: null, radius_lat: null, radius_lng: null })}
            compact
            testId="location-picker"
            enableRadius
            radiusValue={location?.radius_km ? { lat: location.radius_lat, lng: location.radius_lng, radius_km: location.radius_km } : null}
            onRadius={(r) => { setLocation({ radius_km: r.radius_km, radius_lat: r.lat, radius_lng: r.lng }); nav("/buscar"); }}
          />
          <a
            href="/"
            className="inline-flex items-center gap-2 font-heading font-black text-2xl md:text-3xl tracking-tight leading-none"
            data-testid="brand-logo"
          >
            <img
              src="/logo-gear-white.png"
              alt="AlugaJá"
              className="w-12 h-12 md:w-14 md:h-14 object-contain shrink-0 drop-shadow-lg"
            />
            <span>
              Aluga<span className="text-[#FF6B35]">Já</span>
            </span>
          </a>
        </div>
        <form onSubmit={onSearch} className="relative" data-testid="header-search-form">
          <MagnifyingGlass size={20} weight="bold" className="absolute left-3 top-1/2 -translate-y-1/2 text-[#004E98]" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder={placeholder}
            className="w-full bg-white text-[#0F172A] rounded-full pl-11 pr-4 py-2.5 outline-none placeholder:text-slate-400 focus:ring-2 focus:ring-[#FF6B35]"
            data-testid="header-search-input"
          />
        </form>
      </div>
    </header>
  );
}
